<app-admin-header></app-admin-header>
<div class="manual-log-container">
  <app-admin-sidebar></app-admin-sidebar>

  <h2>📥 Manual Stock Additions</h2>

  <div class="filter-row">
    <input type="text" [(ngModel)]="search" placeholder="Search by product..." class="search-input" />
    <input type="date" [(ngModel)]="startDate" />
    <input type="date" [(ngModel)]="endDate" />
    <button (click)="exportToExcel()">⬇ Export to Excel</button>
  </div>

  <table class="stock-table" *ngIf="filteredEntries().length > 0">
  <thead>
    <tr>
      <th>Product</th>
      <th>Old Qty</th>
      <th>New Qty</th>
      <th>Added By</th>
      <th>Date</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let entry of filteredEntries()">
      <td>
        <span class="label">Product:</span>
        <span class="value">{{ entry.stock_item_name }}</span>
      </td>
      <td>
        <span class="label">Old Qty:</span>
        <span class="value">{{ entry.old_quantity }}</span>
      </td>
      <td>
        <span class="label">New Qty:</span>
        <span class="value">{{ entry.new_quantity }}</span>
      </td>
      <td>
        <span class="label">Added By:</span>
        <span class="value">{{ entry.added_by }}</span>
      </td>
      <td>
        <span class="label">Date:</span>
        <span class="value">{{ entry.created_at | date:'short' }}</span>
      </td>
    </tr>
  </tbody>
</table>


  <p *ngIf="filteredEntries().length === 0">No matching manual entries.</p>
</div>
